import { render, staticRenderFns } from "./OStep5.vue?vue&type=template&id=7b1e00a2&scoped=true"
import script from "./OStep5.vue?vue&type=script&lang=js"
export * from "./OStep5.vue?vue&type=script&lang=js"
import style0 from "./OStep5.vue?vue&type=style&index=0&id=7b1e00a2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b1e00a2",
  null
  
)

export default component.exports